import {
  Clock,
  File,
  MapPin,
  User,
  Users,
  UserCheck,
  UserPlus,
  Briefcase,
  Grid,
  Calendar,
  CreditCard,
  CheckSquare,
  LifeBuoy,
  Send
} from "react-feather";

// Naming: a menu item is the thing it opens — a plural noun for a list
// ("Clients", "Employees"), a plain noun for a single view ("Dashboard").
// "... Management" was on four of seven items: it filled the sidebar without
// telling anyone anything. Icons are deliberately distinct per item; four
// identical <Users /> icons made the nav impossible to scan at a glance.
export const superAdminsideMenu = [
  {
    label: "City",
    to: "/city-list",
    icon: <MapPin />
  },
  {
    label: "Ward",
    to: "/ward-list",
    icon: <Clock />,
  },
  {
    label: "Add Supervisor",
    to: "/wardmember-list",
    icon: <User />,
  },
  {
    label: "Admins",
    to: "/admin-list",
    icon: <UserCheck />,
  },
  {
    label: "Staff",
    to: "/staff-list",
    icon: <Users />
  },
  {
    label: "Create Complain",
    to: "/complain-list",
    icon: <File />
  }
]

export const ClientMenu = [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: <Grid />,
  },
  {
    label: "Clients",
    to: "/client-list",
    icon: <Briefcase />,
  },
  {
    label: "Staff",
    to: "/user-list",
    icon: <UserCheck />,
  },
  {
    label: "Employees",
    to: "/employeemanagement",
    icon: <Users />,
  },
  {
    label: "Contractors",
    to: "/contractormanagement",
    icon: <UserPlus />,
  },
  {
    label: "Marketing",
    to: "/marketing",
    icon: <Send />,
    permission: "marketing",
  },
  {
    label: "Approvals",
    to: "/requests",
    icon: <CheckSquare />
  },
  {
    label: "Tickets",
    to: "/tickets",
    icon: <LifeBuoy />
  },
]

export const StaffSideMenu = [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: <Grid />,
  },
  {
    label: "Clients",
    to: "/client-list",
    icon: <Briefcase />,
  },
  {
    label: "Employees",
    to: "/employeemanagement",
    icon: <Users />,
  },
  {
    label: "Contractors",
    to: "/contractormanagement",
    icon: <UserPlus />,
  },
  {
    label: "Attendance",
    to: "/EmpAttendance",
    icon: <Calendar />
  },
  {
    label: "Marketing",
    to: "/marketing",
    icon: <Send />,
    permission: "marketing",
  },
  {
    label: "Approvals",
    to: "/requests",
    icon: <CheckSquare />
  },
  {
    label: "Tickets",
    to: "/tickets",
    icon: <LifeBuoy />
  },
]

export const employeeSideMenu = [
  {
    label: "Marketing",
    to: "/marketing",
    icon: <Send />,
    permission: "marketing",
  },
  {
    label: "Attendance",
    to: "/EmpAttendance",
    icon: <Calendar />
  },
  {
    label: "Reimbursements",
    to: "/requests",
    icon: <CreditCard />
  },
  {
    label: "Support",
    to: "/tickets",
    icon: <LifeBuoy />
  },
];

export const contractorSideMenu = [
  {
    label: "Profile",
    to: "/contractordetails",
    icon: <User />
  },
  {
    label: "Reimbursements",
    to: "/requests",
    icon: <CreditCard />
  },
  {
    label: "Support",
    to: "/tickets",
    icon: <LifeBuoy />
  },
];

export const sideMenu = [];

// Mobile: a bottom tab bar holds 4 destinations + "More" (anything beyond that
// stops being tappable and starts being a list). These are the four an admin
// opens every day; the rest live in the More sheet.
export const mobileTabsFor = (role) => {
  const menu = role === "staff" ? StaffSideMenu : role === "employee" ? employeeSideMenu : role === "contractor" ? contractorSideMenu : ClientMenu;
  const preferred = {
    admin: ["/dashboard", "/client-list", "/employeemanagement", "/requests"],
    staff: ["/dashboard", "/client-list", "/employeemanagement", "/requests"],
    employee: ["/EmpAttendance", "/requests", "/tickets"],
    contractor: ["/contractordetails", "/requests", "/tickets"],
  }[role] || [];

  const tabs = preferred
    .map((to) => menu.find((m) => m.to === to))
    .filter(Boolean);
  const rest = menu.filter((m) => !tabs.includes(m));
  return { tabs, rest };
};
